import { Component, EventEmitter, inject, Input, Output, signal, TemplateRef, WritableSignal } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CropperDialogComponent } from './cropper-dialog/cropper-dialog.component';
import { ImageCroppedEvent } from 'ngx-image-cropper';

@Component({
  selector: 'app-image-control',
  standalone: false,
  templateUrl: './image-control.component.html'
})
export class ImageControlComponent {

  @Input() ratio = 1 / 1;
  @Input() src!: any;
  @Input() index: number = 0;
  @Input() uploadLoader = false;
  @Output() imageReady = new EventEmitter<{ blob: Blob, src: string }>();

  @Input() maxSize = 2;
  fileErrors = {
    type: false,
    size: false
  };
  @Output() errors = new EventEmitter<any>();
  @Output() deleted = new EventEmitter<any>();

  private modalService = inject(NgbModal);
  constructor(
    private sanitizer: DomSanitizer,
  ) { }


  fileSelected(event: any) {
    const file = event.target?.files[0];
    if (file && this.validateFile(file)) {
      const modalRef = this.modalService.open(CropperDialogComponent, {
        centered: true,
        // size: 'lg',
      });
      modalRef.componentInstance.image = file;
      modalRef.componentInstance.ratio = this.ratio;
      modalRef.result.then(
        (result: ImageCroppedEvent) => {
          if (result && result.blob) {
            this.src = this.sanitizer.bypassSecurityTrustUrl(result.objectUrl || result.base64 || '');
            let file: any = result.blob;
            file.name = 'image.png';
            this.imageReady.emit({ blob: file, src: this.src });
          }
        }
      );
    }
    this.errors.emit(this.fileErrors);
  }

  validateFile(file: File): any {
    if (this.fileType(file.name)) {
      this.fileErrors.type = false;
      if ((file.size / (1024 * 1024)) <= this.maxSize) {
        this.fileErrors.size = false;
      } else {
        this.fileErrors.size = true;
        return false;
      }
    } else {
      this.fileErrors.type = true;
      return false;
    }
    return true;
  }
  fileType(fileName: string): any {
    const extension = fileName.split('.')?.pop()?.toLowerCase();
    switch (extension) {
      case 'jpeg':
      case 'jpg':
        return 'jpg';
      case 'png':
        return 'png';
      default:
        return false;
    }
  }
}
